export class MessageTreeviewItemExpand {
   public static readonly type = '[Samwin Message Skill Browser] Message Treeview Item Expand';

   constructor(public groupKey: string) {}
}

export class MessageTreeviewItemCollapse {
   public static readonly type = '[Samwin Message Skill Browser] Message Treeview Item Collapse';

   constructor(public groupKey: string) {}
}

export class MessageTreeviewEntrySelected {
   public static readonly type = '[Samwin Message Skill Browser] Message Treeview Entry Selected';

   constructor(public groupKey: string) {}
}

export class MessageTreeviewSelectNextEntry {
   public static readonly type = '[Samwin Message Skill Browser] Message Treeview Select Next Entry';

   constructor(public direction: 'up' | 'down', public step = 1) {}
}

export class MessageTreeviewItemExpandSelectedEntry {
   public static readonly type = '[Samwin Message Skill Browser] Message Treeview Item Expand Selected Entry';

   constructor() {}
}

export class MessageTreeviewItemCollapseSelectedEntry {
   public static readonly type = '[Samwin Message Skill Browser] Message Treeview Item Collapse Selected Entry';

   constructor() {}
}
